import { render } from "./Contact.vue?vue&type=template&id=5513cabf&scoped=true"
import script from "./Contact.vue?vue&type=script&lang=js"
export * from "./Contact.vue?vue&type=script&lang=js"

import "./Contact.vue?vue&type=style&index=0&id=5513cabf&scoped=true&lang=css"

import exportComponent from "/Users/dmitriykuptsov/workspace/front-end-development/strangebit.io/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5513cabf"]])

export default __exports__